import {
  Component,
  Output,
  Input,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { CompsTickerModalComponent } from "../../comps-page/comps-ticker-modal/comps-ticker-modal.component";

import {
  ValuationGridData,
  VsPeerState,
  UserSettingObject,
  ValuationPeriodState,
} from "../valuation-page.model";
import { PeriodUserSettingObj } from "@va/core-library/period-filter";
import { ValuationPageDataService } from "../valuation-page-data.service";
import {
  getUserSettingDetails,
  updateUserSettingDetails,
  getTickersCompanyId,
  getTickersId,
  getSelectedRatiosId,
  getIsDenomSelected,
  getIsDenomYoySelected,
  createGridData,
  getExtraLogDetails,
  getUpdatedCompanyIdDifference,
} from "../valuation-page-utils";
import {
  VS_PEER_TAB,
  VALUATION_LOG_ACTION_FEATURES,
  VALUATION_PAGE,
} from "../valuation-page.constant";
import { faBars, faThLarge } from "@fortawesome/pro-light-svg-icons";
import { AppService } from "src/app/app.service";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import { VAIconRegistryService, menu, table } from "@va/core-library/icons";
@Component({
  selector: "app-valuation-page-vspeers",
  templateUrl: "./valuation-page-vspeers.component.html",
  styleUrls: ["./valuation-page-vspeers.component.scss"],
})
export class ValuationPageVspeersComponent {
  @Input() currentTicker: string;
  @Input() currentCompany: number;
  @Input() isMetaReady = false;
  @Input() state: VsPeerState;
  @Input() watchlistData: Array<any> = [];
  @Input() recentlyVisitedCompanies: Array<any> = [];
  @Input() suggestedPeers: Array<any> = [];
  @Input() isTickerFilterDataReady = false;
  @Input() isUserPeriodCalSettingsInProgress = false;
  @Input() highlightGAAP = false;
  @Input() visible = false;
  @Input() apiEP: string = window.apiUrl;

  @Output() onPeersChange: EventEmitter<any> = new EventEmitter();
  @Output() onPeriodChange: EventEmitter<any> = new EventEmitter();
  @Output() saveRatios = new EventEmitter();
  @Output() onCurrencyChange = new EventEmitter();
  @Output() onPeriodCalculationChange: EventEmitter<any> = new EventEmitter();
  @Output() showSnackBarMessage: EventEmitter<any> = new EventEmitter();
  @Output() onDeletePeer: EventEmitter<any> = new EventEmitter();

  suggestedRatioLines;
  ratioLineItemsData;
  orderedRatioData;
  selectedRatioId;
  isLineItemDataReady = false;

  faThLarge = faThLarge;
  faBars = faBars;
  tabType = "vsPeers";

  currentTabId = VS_PEER_TAB.id;
  tickerIds = [];
  gridData: ValuationGridData = {};
  tickersModal: NzModalRef;
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: false,
    },
  ];
  isExportPopoverVisible = false;
  periodsWithAvailableData;

  //loaders
  isDataInProgress = true;
  isUserSettingsInProgress = false;
  isPeersDataReady = false;
  isTickerUpdationInProgress = false;
  currencyUpdating = false;
  isExportInProgress = false;

  userSettingDetails: UserSettingObject;
  currency: string;
  isValuation = true;
  orientationValue: string;
  isVisibleEditTickerModal = false;
  isVisibleEditLiModal = false;
  leftModalDataReady = false;
  snackbarMessage = "";

  lineItemMaxLimit = 20;
  selectedLineItemCount = 0;
  lineItemsModal: NzModalRef;

  constructor(
    private dataService: ValuationPageDataService,
    private modalService: NzModalService,
    private appService: AppService,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([menu, table]);
  }

  /**
   * It destroys Edit ticker modal
   */
  destroyTickerModal(): void {
    this.tickersModal.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    // update ratio line item data on ticker change
    if (
      this.isMetaReady &&
      changes.state &&
      changes.state.currentValue &&
      changes.state.previousValue &&
      changes.state.currentValue.ticker_info !==
        changes.state.previousValue.ticker_info
    ) {
      this.tickerIds = getTickersId(changes.state.currentValue.ticker_info);
      this.getRatioLineItemData();
      this.getPeriodsWithAvailableData(this.tickerIds);
    }

    if (changes.state && changes.state.currentValue) {
      //react to changes in state pushed from page component
      if (changes.state.currentValue.ratios) {
        if (this.orientationValue === undefined) {
          this.orientationValue = changes.state.currentValue.defaultOrientation;
        }
        const orderedRatioItems = this.orderedRatioData
          ? this.orderedRatioData.map(
              (item) => item.uniquesliid || item.sliid || item.sli_id,
            )
          : undefined;
        this.gridData = createGridData(
          changes.state.currentValue,
          orderedRatioItems,
        );
        this.fetchAndHandleValuationData(this.gridData.ratios, this.state);
      }
    }

    // Set userSetting obj on meta completion
    if (
      changes.isMetaReady &&
      changes.isMetaReady.currentValue &&
      changes.isMetaReady.currentValue !== changes.isMetaReady.previousValue
    ) {
      if (
        this.state &&
        this.state.ratios &&
        this.state.period &&
        this.state.currency &&
        this.state.ticker_info &&
        this.orientationValue
      ) {
        this.userSettingDetails = getUserSettingDetails({
          tabType: this.currentTabId,
          currentTicker: this.currentTicker,
          ratios: this.state.ratios,
          periods: this.state.period,
          tickers: this.state.ticker_info,
          currency: this.state.currency,
          orientation: this.orientationValue,
        });
      }

      if (this.state && this.state.ratios) {
        this.selectedRatioId =
          getSelectedRatiosId(this.state.ratios.ratio_details) || [];
        this.selectedLineItemCount = this.selectedRatioId.length;
      }
    }
  }

  /**
   * It call the get_std_line_items api and formats the response
   */
  getRatioLineItemData() {
    this.isLineItemDataReady = false;
    this.dataService.getStdLineItems(this.tickerIds).subscribe((res) => {
      this.ratioLineItemsData = res.data.filter(
        (d) => d.tab_short_name === "SL" || d.tab_short_name === "VR",
      );
      if (this.state && this.state.ratios) {
        this.selectedRatioId =
          getSelectedRatiosId(this.state.ratios.ratio_details) || [];
        this.selectedLineItemCount = this.selectedRatioId.length;
      }

      const _suggestedLines: Array<any> = res.data.filter(
        (d) => d.tab_short_name === "SL",
      );
      this.suggestedRatioLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              ...l,
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];

      if (this.suggestedRatioLines.length > 0) {
        this.suggestedRatioLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedRatioLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      } else {
        this.suggestedRatioLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedRatioLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      }
      this.isLineItemDataReady = true;
    });
  }

  /**
   * It is used to trigger valuation data call for peer tab and store the result in gridData
   * @param ratios selected ratios
   * @param state present state of VsPeers tab
   */
  fetchAndHandleValuationData(ratios: Array<string>, state: VsPeerState) {
    this.isDataInProgress = true;
    this.dataService
      .getValuationData(ratios, this.gridData, state, "peer")
      .subscribe((gridData: ValuationGridData) => {
        this.gridData = { ...gridData };
        this.isDataInProgress = false;
        this.appService.logUserAction(
          {},
          this.currentTicker,
          "",
          VALUATION_LOG_ACTION_FEATURES.dataCall,
          getExtraLogDetails(
            this.currentCompany,
            VS_PEER_TAB.label,
            this.userSettingDetails,
            this.state.period_calculation,
          ),
          "",
          VALUATION_PAGE,
        );
      });
  }

  /**
   * This function is fired when the save currency event is fired from the currency filter component.
   * It updates the currency in the state and calls the saveusersettings api to save it.
   * @param item selected currency
   */
  updateCurrency(item: string) {
    this.currencyUpdating = true;
    this.isUserSettingsInProgress = true;
    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        currency: item,
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onCurrencyChange.emit({
            item,
            magMsg: response["magnitude_message"],
          });
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateCurrency,
            getExtraLogDetails(
              this.currentCompany,
              VS_PEER_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
          this.currencyUpdating = false;
          this.isUserSettingsInProgress = false;
        }
      });
  }

  /**
   * It handles for ticker deletion event raised from valuation grid.
   * It is responsible for saving user settings and trigger state change for removing ticker from state
   * @param tickerData data of the ticker to be deleted
   */
  handleOnDeleteTicker(tickerData) {
    const tickers = this.state.ticker_info.filter((_ticker) => {
      return _ticker.ticker !== tickerData.ticker;
    });
    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        tickers: getTickersCompanyId(tickers),
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onDeletePeer.emit(tickerData);
          this.snackbarInfo.message = `${tickerData.ticker} has been removed from the table.`;
          this.snackbarInfo.type = "success";
          this.showSnackBarMessage.emit(this.snackbarInfo);
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.removeTicker,
            {
              ...getExtraLogDetails(
                this.currentCompany,
                VS_PEER_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              removed_ticker: tickerData.cid ? [tickerData.cid] : undefined,
            },
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * It executes on ticker selection from on-screen ticker filter
   * If selected ticker already exist then it shows toast message, otherwise it executes the updateTickers method
   * @param {object} tickerData - current selected ticker
   */
  handleSearchTickerSelection(tickerData) {
    const { value } = tickerData;
    if (this.tickerIds.includes(value.ticker)) {
      this.snackbarInfo.message = "This ticker is already present.";
      this.snackbarInfo.type = "info";
      this.showSnackBarMessage.emit(this.snackbarInfo);
    } else {
      value["cid"] = value.companyid || value.cid;
      value["name"] = value.n || value.name || value.full_name;
      this.updateTickers([...this.state.ticker_info, value], value);
    }
  }

  /**
   * It updates the peer companies data.
   * It posts the updated peer to userSetting api
   * It emits onPeersChange which is useful for updating the state object
   * @param {array} ticker - array of all selected tickers
   * @param {object} addedTicker - current selected ticker
   */
  updateTickers(tickers, addedTicker?: { ticker: string; [x: string]: any }) {
    this.isUserSettingsInProgress = true;
    const updatedTickers = tickers.map((item) => ({
      ...item,
      tickerDeleteDisabled: item.ticker === this.currentTicker,
    }));
    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        tickers: getTickersCompanyId(updatedTickers),
      },
    );
    const existingTickers = [...this.state.ticker_info];

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onPeersChange.emit(updatedTickers);
          // Show toast message once ticker is added to the table
          if (addedTicker && addedTicker.ticker) {
            this.snackbarInfo.message = `${addedTicker.ticker} has been added to the table.`;
            this.snackbarInfo.type = "success";
            this.showSnackBarMessage.emit(this.snackbarInfo);
          }

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.addTicker,
            {
              ...getExtraLogDetails(
                this.currentCompany,
                VS_PEER_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              added_ticker: getUpdatedCompanyIdDifference(
                existingTickers,
                updatedTickers,
              ),
            },
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });

    if (this.tickersModal) {
      this.destroyTickerModal();
    }
  }

  /**
   * Executes on click of Edit tickers button.
   * It creates Ticker Modal
   */
  handleEditTickerClick() {
    const tickerInfo =
      this.state && this.state.ticker_info ? [...this.state.ticker_info] : [];
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: CompsTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: tickerInfo,
        watchlists: this.watchlistData,
        recentlyVisitedCompanies: this.recentlyVisitedCompanies,
        maxHeight: "340px",
        type: "edit",
        mptApplicable: false,
        maxTickers: 50,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClass"name": "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data.modalData);
          },
          disabled: (data) => {
            return data.modalData.length > 50 || data.modalData.length === 0;
          },
        },
      ],
    });
  }

  /**
   * This function is fired when the save ratio event is emitted from
   * the ratio filter component.
   * This updates the ratios list in the state and calls the saveusersetting api to save it.
   * It calls the snackbar with appropriated added and removed ratios.
   * @param e ratio data when the event is emitted
   */
  handleRatios(e) {
    this.isUserSettingsInProgress = true;
    const removedRatio = [];
    const addedRatio = [];
    this.snackbarInfo.message = "";
    e.include.forEach((data, index) => {
      this.state.ratios.include[index]["selected"] = data["checked"];
    });
    e.ratios.forEach((data, index) => {
      if (data["selected"] && !data["checked"]) {
        removedRatio.push(data["label"]);
      }
      if (!data["selected"] && data["checked"]) {
        addedRatio.push(data["label"]);
      }
      this.state.ratios.ratio_details[index]["ratio"]["selected"] =
        data["checked"];
    });

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        selectedRatios: getSelectedRatiosId(this.state.ratios.ratio_details),
        isDenomSelected: getIsDenomSelected(this.state.ratios.include),
        isDenomYoySelected: getIsDenomYoySelected(this.state.ratios.include),
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.saveRatios.emit({
            ratios: this.state.ratios.ratio_details,
            include: this.state.ratios.include,
          });

          if (addedRatio.length) {
            this.snackbarInfo.message = `${addedRatio} have been added to the table.`;
          }
          if (removedRatio.length) {
            this.snackbarInfo.message += ` ${removedRatio} have been removed from the table.`;
          }

          if (this.snackbarInfo.message) {
            this.snackbarInfo.type = "success";
            this.showSnackBarMessage.emit(this.snackbarInfo);
          }

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateRatio,
            getExtraLogDetails(
              this.currentCompany,
              VS_PEER_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * It emits `onPeriodCalculationChange` with selected radio values
   * @param {{ntmStmValue: string, calendariozationValue: string}} value: selected radio values from period calculation popup
   */
  handlePeriodCalculationApply(value) {
    this.onPeriodCalculationChange.emit({
      value,
      userSettingDetails: this.userSettingDetails,
    });
  }

  /**
   * This method is called on change of the orientation button.
   * It updates the value of Orientation in the state and calls
   * saveusersettings api to save it.
   * @param e orientation value
   */
  handleOrientation(e) {
    this.isUserSettingsInProgress = true;
    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        orientation: e,
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.orientationValue = e;

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateViewOrientation,
            getExtraLogDetails(
              this.currentCompany,
              VS_PEER_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
          this.store.dispatch(new DeleteDpParams());
        }

        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It emits `onPeriodChange` with selected periodData
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: ValuationPeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const { updatedPeriodData, periodUserSettingData } = periodData;

    this.isUserSettingsInProgress = true;

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      periodUserSettingData,
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onPeriodChange.emit(updatedPeriodData);
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updatePeriod,
            getExtraLogDetails(
              this.currentCompany,
              VS_PEER_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * Executes on click of export dropdown list item
   * It closes the dropdown on selecting list items. Also one can update the loader status when excel to export action is in progress
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleETEListItemClick(id) {
    this.isExportInProgress = true;
    let extra = {};
    let type = "";
    let page = "";
    if (this.userSettingDetails.orientation === "grid") {
      type = "valuation vspeers grid";
      page = "valuation vspeers grid page";
      extra = {
        export_type: id,
        template_type: "valuation vs peers grid",
        source: "Consensus",
      };
    }

    if (this.userSettingDetails.orientation === "list") {
      type = "valuation vspeers list";
      page = "valuation vspeers list page";
      extra = {
        export_type: id,
        template_type: "valuation vs peers list",
        source: "Consensus",
      };
    }

    this.appService
      .exportToExcel(type, this.currentTicker, extra)
      .subscribe((res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.export,
            {
              ...getExtraLogDetails(
                this.currentCompany,
                VS_PEER_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              beginning_state_referrer: page,
              export_type: 1,
              tracker_id: trackerId,
              file_name: fileName,
            },
            "",
            VALUATION_PAGE,
          );
        }
        this.isExportInProgress = false;
      });

    // close export to excel popover
    this.isExportPopoverVisible = false;
  }

  /**
   * It executes on the search and selection of line item
   * It adds this line item to existing list
   * @param {object} e: selected line item
   */
  onSearchedLi(e) {
    if (!e) {
      return;
    }

    const selectedRatioLineIds = this.state.ratios
      ? getSelectedRatiosId(this.state.ratios.ratio_details)
      : [];

    // check if already existing line items are more or equal to max limit. If yes don't add new item
    if (selectedRatioLineIds.length >= this.lineItemMaxLimit) {
      return;
    }

    const value = { ...e, parent: undefined, sliid: e.sliid || e.sli_id };
    const alreadyExist = selectedRatioLineIds.includes(value.sliid);

    if (!alreadyExist) {
      this.isUserSettingsInProgress = true;
      const allSelectedRatiosId = selectedRatioLineIds.concat(value.sliid);

      //update the selected check of ratio item
      const updatedRatios = this.state.ratios.ratio_details.map((item) => {
        const ratioItem = item.ratio;
        if (ratioItem.usliid === value.sliid) {
          item.ratio.selected = true;
        }
        return item;
      });

      this.userSettingDetails = updateUserSettingDetails(
        this.userSettingDetails,
        {
          selectedRatios: allSelectedRatiosId,
        },
      );
      this.dataService
        .saveUserSettings(this.userSettingDetails)
        .subscribe((response: { status: string; data }) => {
          if (response.status === "success") {
            this.saveRatios.emit({
              ratios: updatedRatios,
              include: this.state.ratios.include,
            });
            if (updatedRatios) {
              this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
              this.selectedLineItemCount = this.selectedRatioId.length;
              this.orderedRatioData = this.orderedRatioData
                ? this.orderedRatioData.concat(value)
                : undefined;
            }
            this.snackbarInfo.message = `${value.label} has been added to the table`;
            this.snackbarInfo.type = "success";
            this.showSnackBarMessage.emit(this.snackbarInfo);
            (error) => {
              console.error(error);
            };
            this.appService.logUserAction(
              {},
              this.currentTicker,
              "",
              VALUATION_LOG_ACTION_FEATURES.updateRatio,
              getExtraLogDetails(
                this.currentCompany,
                VS_PEER_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              "",
              VALUATION_PAGE,
            );
            this.isUserSettingsInProgress = false;
          }
        });
    } else {
      this.leftModalDataReady = true;
      this.snackbarInfo.message = "This line item is already present.";
      this.snackbarInfo.type = "info";
      this.showSnackBarMessage.emit(this.snackbarInfo);
    }
  }

  /**
   * It adds line items selected from the edit modal to the list
   * @param {object} data: selected data from line item modal
   */
  updateEditModalLineItems(data) {
    const { modalData, selectedRatioDenomItems = [] } = data;
    this.orderedRatioData = [...modalData];
    this.isUserSettingsInProgress = true;
    const selectedRatioItems = modalData.map(
      (item) => item.uniquesliid || item.sliid || item.sli_id,
    );
    const isDenomSelected = !!(
      selectedRatioDenomItems && selectedRatioDenomItems.includes("denom")
    );
    const isDenomYoySelected = !!(
      selectedRatioDenomItems && selectedRatioDenomItems.includes("denom_yoy")
    );

    //update the selected check of ratio item
    const updatedRatios = this.state.ratios.ratio_details.map((item) => {
      const ratioItem = item.ratio;
      item.ratio.selected = selectedRatioItems.includes(ratioItem.usliid);
      return item;
    });

    const updatedIncludes = this.state.ratios.include.map((item) => ({
      ...item,
      selected: selectedRatioDenomItems.includes(item.name),
    }));

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        selectedRatios: selectedRatioItems,
        isDenomSelected,
        isDenomYoySelected,
      },
    );

    this.lineItemsModal.destroy();

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.saveRatios.emit({
            ratios: updatedRatios,
            include: updatedIncludes,
          });

          if (updatedRatios) {
            this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
            this.selectedLineItemCount = this.selectedRatioId.length;
          }

          (error) => {
            console.error(error);
          };
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateRatio,
            getExtraLogDetails(
              this.currentCompany,
              VS_PEER_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
          this.isUserSettingsInProgress = false;
        }
      });
  }

  /**
   * It executes on the click of Edit button of lien item filter
   * It creates the Line item modal withe required information and opens it.
   */
  handleEditLineItemsButtonClick() {
    let selectedRatioItems = [];
    if (this.orderedRatioData) {
      selectedRatioItems = this.orderedRatioData;
    } else {
      selectedRatioItems = this.state.ratios.ratio_details
        .filter((item) => item.ratio.selected)
        .map((el) => {
          const sliId = el.ratio.usliid || el.ratio.sliid || el.ratio.el.sli_id;
          return {
            ...el.ratio,
            sli_id: sliId,
            name: el.ratio.label,
            is_valuation_ratio: true,
          };
        });
    }

    this.lineItemsModal = this.modalService.create({
      nzTitle: "Edit Line Items",
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: selectedRatioItems,
        stdLineItems: this.ratioLineItemsData,
        max: this.lineItemMaxLimit,
        maxHeight: "290px",
        selectedPeriod: [],
        tickers: [this.currentTicker],
        createSource: "consensus",
        ratioDenomData: this.state.ratios.include,
        showDenomCheckbox:
          this.orientationValue && this.orientationValue === "grid",
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditModalLineItems(data);
          },
          disabled: (data) => {
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
    });
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
